import { Component, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { DxFormComponent } from 'devextreme-angular';
import { ToastrService } from 'ngx-toastr';
import { DeclineMessageModel } from 'src/app/models/decline-message.model';
import { ApprovalRequestService } from 'src/app/services/approval-request.service';
import { LoadingService } from 'src/app/services/loading.service';
import { SubscriptionService } from 'src/app/services/subscriptions/subscription.service';

@Component({
  selector: 'app-reject-request-modal',
  standalone: false,
  templateUrl: './reject-request-modal.component.html',
  styleUrl: './reject-request-modal.component.scss',
})
export class RejectRequestModalComponent {
  @ViewChild('declineForm', { static: false }) 
  formComponent!: DxFormComponent;
  
  @Input()
  currentSubscriptionId!: string;

  @Input() showModal = false;
  @Output() showModalChange = new EventEmitter<boolean>();

  @Output() onCancel = new EventEmitter();
  @Output() onReject = new EventEmitter();

  formData: DeclineMessageModel = { 
    reason: '' 
  };

  constructor(
    private toastrService: ToastrService,
    private loadingService: LoadingService,
    private translateService: TranslateService,
    private subscriptionService: SubscriptionService,
  ) {

  }

  public onSendClick() {
    const isFormValid = this.formComponent.instance.validate().isValid;;

    if (!isFormValid) {
      this.toastrService.error(
        this.translateService.instant('VALIDATIONS.VALUES-NOT-VALID')
      );
      return;
    }
     this.loadingService.load(
      this.subscriptionService.rejectRequest(
        this.currentSubscriptionId!,
        this.formData
      )
    ).subscribe({
        next: () => {
          this.toastrService.success(
            this.translateService.instant(
              'SUBSCRIPTIONS.REJECTED-REQUEST-SUCCESSFULLY'
            )
          );

          this.onReject.emit();
          this.close();
        },
        error: () => {
          this.toastrService.error(
            this.translateService.instant(
              'COMMON.AN-ERROR-HAS-OCCURRED'
            )
          );
        },
      });
  }

  public cancel() {
    this.onCancel.emit();
    this.close();
  }

  close() {
    this.showModal = false;
    this.showModalChange.emit(this.showModal);
  }
}
